<template>
  <div class="carousel-section">
    <div class="owl-carousel owl-theme" ref="owlCarousel">
      <div class="item" v-for="(image, index) in images" :key="index">
        <img :src="image.src" :alt="image.alt">
      </div>
    </div>
    
    <!-- Custom Navigation Dots -->
    <div class="custom-dots">
      <span 
        v-for="i in 4" 
        :key="i" 
        :class="{ 'active': currentDot === i-1 }"
        @click="goToSlide(i-1)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OwlCarousel',
  data() {
    return {
      currentDot: 0,
      images: [
        { 
          src: require('../assets/1.C1JQKCyB.png'),
          alt: 'Add Count'
        },
        { 
          src: require('../assets/2.DKIa9yOK.png'),
          alt: 'Data Statistics'
        },
        { 
          src: require('../assets/3.BM15nvB1.png'),
          alt: 'Set Goals'
        },
        { 
          src: require('../assets/4.IH2Xum8_.png'),
          alt: 'History Records'
        },
        { 
          src: require('../assets/5.BcvX-KDb.png'),
          alt: 'Data Analysis'
        },
        { 
          src: require('../assets/6.CxKgRPGU.png'),
          alt: 'Smart Reminders'
        }
      ],
      owlCarousel: null
    }
  },
  mounted() {
    this.initOwlCarousel();
  },
  methods: {
    initOwlCarousel() {
      // 动态加载Owl Carousel脚本和样式
      this.loadScript('https://code.jquery.com/jquery-3.6.0.min.js')
        .then(() => {
          return Promise.all([
            this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js'),
            this.loadCSS('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.carousel.min.css'),
            this.loadCSS('https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.theme.default.min.css')
          ]);
        })
        .then(() => {
          // 初始化Owl Carousel
          setTimeout(() => {
            if (window.jQuery && window.jQuery.fn.owlCarousel) {
              const $owlCarousel = window.jQuery(this.$refs.owlCarousel);
              this.owlCarousel = $owlCarousel.owlCarousel({
                loop: true,
                margin: 5,
                autoplay: true,
                autoplayTimeout: 2000,
                autoplayHoverPause: true,
                dots: false, // 禁用默认导航点
                responsive: {
                  0: {
                    items: 1,
                    margin: 0
                  },
                  480: {
                    items: 1,
                    margin: 3
                  },
                  600: {
                    items: 1, // 在600px以下只显示一张图片
                    margin: 5
                  },
                  768: {
                    items: 2, // 在768px以上显示两张图片
                    margin: 5
                  },
                  900: {
                    items: 3
                  },
                  1200: {
                    items: 4
                  }
                }
              }).data('owl.carousel');
              
              // 监听轮播图变化事件
              $owlCarousel.on('changed.owl.carousel', (event) => {
                // 更新当前点的索引
                this.currentDot = Math.floor(event.item.index / 2) % 4;
              });
            }
          }, 500);
        })
        .catch(error => {
          console.error('Failed to load Owl Carousel:', error);
        });
    },
    goToSlide(index) {
      if (this.owlCarousel) {
        // 计算要跳转的实际索引
        const realIndex = index * 2;
        this.owlCarousel.to(realIndex);
        this.currentDot = index;
      }
    },
    loadScript(src) {
      return new Promise((resolve, reject) => {
        // 检查脚本是否已经加载
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }
        
        const script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },
    loadCSS(href) {
      return new Promise((resolve, reject) => {
        // 检查样式是否已经加载
        if (document.querySelector(`link[href="${href}"]`)) {
          resolve();
          return;
        }
        
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
      });
    }
  }
}
</script>

<style scoped>
.carousel-section {
  width: 100%;
  margin: 30px auto;
  position: relative;
}

.owl-carousel {
  margin-top: 30px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  overflow: hidden;
}

.owl-carousel .item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}

.owl-carousel img {
  width: 100%;
  max-height: 600px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

/* 自定义导航点样式 */
.custom-dots {
  text-align: center;
  margin-top: 20px;
}

.custom-dots span {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 0 5px;
  background-color: #ccc;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.custom-dots span.active {
  background-color: #4a9ad8;
  transform: scale(1.2);
}

.custom-dots span:hover {
  background-color: #999;
}

@media (max-width: 768px) {
  .carousel-section {
    margin: 20px auto;
  }

  .owl-carousel {
    margin-top: 20px;
    border-radius: 10px;
  }

  .owl-carousel .item {
    padding: 3px;
    min-height: 600px;
  }

  .owl-carousel img {
    width: 100%;
    height: auto;
    max-height: none;
    object-fit: contain;
    border-radius: 8px;
  }
  
  .custom-dots {
    margin-top: 15px;
  }
  
  .custom-dots span {
    width: 10px;
    height: 10px;
    margin: 0 4px;
  }
}

@media (max-width: 480px) {
  .carousel-section {
    margin: 15px auto;
  }

  .owl-carousel {
    margin-top: 15px;
    border-radius: 8px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
  
  .owl-carousel .item {
    padding: 2px;
    min-height: 500px;
  }

  .owl-carousel img {
    width: 100%;
    height: auto;
    max-height: none;
    object-fit: contain;
    border-radius: 6px;
  }
  
  .custom-dots {
    margin-top: 12px;
  }
  
  .custom-dots span {
    width: 8px;
    height: 8px;
    margin: 0 3px;
  }
}
</style> 